export default __webpack_public_path__ + "static/media/logo.edc5628e.svg";